import {ConfigObjectType} from '@wallaby-ui/core';
import * as React from 'react';

import HaiListLayout from './HaiListLayout';

interface OwnProps {
  config: ConfigObjectType;
  route: string;
  componentParams?: any;
}

type Props = OwnProps;

export const HaiListLayoutContainer: React.FC<Props> = (props) => {
  const {config, ...restProps} = props;
  return <HaiListLayout {...restProps} config={config} />;
};
